import React from "react";
import HeroType1 from "../assets/hero/HeroType1";
import HomeGallery from "../assets/sections/home/HomeGallery";
import OurTeam from "../assets/sections/home/OurTeam";
import OurServices from "../assets/sections/home/OurServices";
import BookMeeting from "../assets/sections/BookMeeting";
import Footer from "../assets/sections/Footer";
import AboutUs from "../assets/sections/home/AboutUs";
import CursorT1 from "../assets/cursor/CursorT1";

export default function Home() {
  return (
    <>
      <HeroType1 />
      <HomeGallery />
      <OurTeam />
      <AboutUs />
      <OurServices />
      <BookMeeting />
      <Footer />
      <CursorT1 />
    </>
  );
}
